class ModuleTracker {
    constructor(section, {
        observeSelector,
        ga4Id = 'G-6HNCZQ3HQN',
        moduleType,
        selector: {
            addSelector = null,
            checkoutSelector = null,
            interactSelector = null
        } = {},
        on: {
            onAdd = null,
            onCheckout = null,
            onInteract = null
        } = {},
        threshold = 0.5,
        conversion = false,
        debug_mode = false
    }) {
        this.section = typeof section === 'string' ? document.querySelector(section) : section;
        if (!this.section) {
            throw new Error(`Section "${section}" not found`);
        }
        this.STORAGE_KEY = '_tracker_module_conversion';
        this.trackerData = this.loadFromLocalStorage();
        this.conversion = conversion;
        this.moduleType = moduleType;
        this.threshold = threshold;
        this.debug_mode = debug_mode;
        this.observeSelector = observeSelector;
        this.addEls = addSelector ? this.section.querySelectorAll(addSelector) : [];
        this.checkoutEls = checkoutSelector ? this.section.querySelectorAll(checkoutSelector) : [];
        this.interactEls = interactSelector ? this.section.querySelectorAll(interactSelector) : [];

        this.ga4Id = ga4Id;

        this.initObserver();
        this.init();
    }

    initObserver() {
        const items = this.section.querySelectorAll(this.observeSelector);
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const moduleTitle = entry.target.dataset.moduleTitle || null;
                    this.trackEvent('module_view', moduleTitle);
                    obs.unobserve(entry.target);
                }
            });
        }, {
            threshold: this.threshold,
            rootMargin: '0px'
        });

        items.forEach(el => observer.observe(el));
    }
    init() {
        if (this.addEls.length > 0) {
            this.addEls.forEach(el => {
                el.addEventListener('click', () => {
                    this.trackEvent('module_add', el.dataset.moduleTitle);
                });
            });
        }
        if (this.checkoutEls.length > 0) {
            this.checkoutEls.forEach(el => {
                el.addEventListener('click', () => {
                    this.trackEvent('module_checkout', el.dataset.moduleTitle);
                });
            });
        }
        if (this.interactEls.length > 0) {
            this.interactEls.forEach(el => {
                el.addEventListener('click', () => {
                    this.trackEvent('module_interact', el.dataset.moduleTitle);
                });
            });
        }
    }

    trackEvent(eventName, module_title) {
        const currentPath = window.location.pathname;
        const payload = { module_type: this.moduleType, eventPath: currentPath };
        if (module_title) payload.module_title = module_title;
        if (this.debug_mode) payload.debug_mode = true;
        if (this.conversion && eventName !== 'module_view' && module_title) {

            const currentPath = window.location.pathname;
            const entry = { module_title, eventPath: currentPath };

            if (!this.trackerData[this.moduleType]) {
                this.trackerData[this.moduleType] = [];
            }

            const existingIndex = this.trackerData[this.moduleType].findIndex(item => item.module_title === module_title);

            if (existingIndex > -1) {
                this.trackerData[this.moduleType][existingIndex] = entry;
            } else {
                this.trackerData[this.moduleType].push(entry);
            }

            this.saveToLocalStorage(this.trackerData);
        }
        gtag('event', eventName, payload);
        console.log('gtag========>', eventName, payload)
    }

    loadFromLocalStorage() {
        if (!this.conversion) return {};

        try {
            const raw = localStorage.getItem(this.STORAGE_KEY);
            const parsed = raw ? JSON.parse(raw) : {};
            return typeof parsed === 'object' && parsed !== null ? parsed : {};
        } catch (e) {
            return {};
        }
    }
    saveToLocalStorage(data) {
        if (!this.conversion) return;
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
    }
}